import { MutationTree } from "vuex";
import { ReportsState } from "./state";
import { reportsMutations } from "./types";
import { log } from "@/core/logger";
import { WorkflowState } from "@/models/workflow-state";
import { CaseReport, Observation, SlideReport } from "@/store/reports/models";

const mutations: MutationTree<ReportsState> = {
  [reportsMutations.SET_CASE_REPORT](
    state: ReportsState,
    payload: { caseId: string; caseReport: CaseReport }
  ): void {
    try {
      log(`setting report for case ${payload.caseId}`);
      state.casesReports[payload.caseId] = payload.caseReport;
    } catch (error: any) {
      log(`failed setting case report`, error);
    }
  },

  [reportsMutations.SET_SLIDE_REPORT](
    state: ReportsState,
    payload: { caseId: string; slideId: string; slideReport: SlideReport }
  ): void {
    try {
      log(`setting report for slide ${payload.slideId}`);
      state.casesReports[payload.caseId].slidesReports[payload.slideId] = payload.slideReport;
    } catch (error: any) {
      log(`failed setting slide report`, error);
    }
  },

  [reportsMutations.UPDATE_SLIDE_OBSERVATIONS](
    state: ReportsState,
    payload: { caseId: string; slideId: string; slideReport: SlideReport }
  ): void {
    log(`updating slide report for slide ${payload.slideId}`);
    state.casesReports[payload.caseId].slidesReports[payload.slideId] = {
      ...state.casesReports[payload.caseId].slidesReports[payload.slideId],
      ...payload.slideReport,
    };
  },

  [reportsMutations.DELETE_SLIDE_REPORT](
    state: ReportsState,
    payload: { caseId: string; slideId: string }
  ): void {
    log(`deleting slide report for slide ${payload.slideId}`);
    delete state.casesReports[payload.caseId].slidesReports[payload.slideId];
  },

  [reportsMutations.SET_ACTIVE_CASE_REPORT_ID](
    state: ReportsState,
    payload: { reportId: number }
  ): void {
    log(`updating report: ${payload.reportId}`);
    state.activeReportId = payload.reportId;
  },

  [reportsMutations.SET_SLIDE_WORKFLOW_STATE](
    state: ReportsState,
    payload: { caseId: string; slideId: string; workflowState: WorkflowState }
  ): void {
    log(`updating slide ${payload.slideId} with workflow state: ${payload.workflowState}`);
    state.casesReports;
  },

  [reportsMutations.SET_SLIDE_COMPLETE](
    state: ReportsState,
    payload: { caseId: string; slideId: string; isComplete: boolean }
  ): void {
    try {
      log(`toggle slide ${payload.slideId} complete`);
      state.casesReports[payload.caseId].slidesReports[payload.slideId].isComplete =
        payload.isComplete;
    } catch (error: any) {
      log("error toggling slide completeness", error);
    }
  },

  [reportsMutations.UPDATE_CASE_COMMENTS](
    state: ReportsState,
    payload: { caseId: string; comments: string }
  ): void {
    state.casesReports[payload.caseId].comments = payload.comments;
  },

  [reportsMutations.SET_CASE_OBSERVATIONS](
    state: ReportsState,
    payload: { caseId: string; observations: Observation[] }
  ): void {
    state.casesReports[payload.caseId].observations = payload.observations;
  },

  [reportsMutations.UPDATE_CASE_COMPLETENESS](
    state: ReportsState,
    payload: { caseId: string; isComplete: boolean; completedOn: Date; completedBy: string }
  ): void {
    // TODO: Refactor Case Workflow State Logic
    state.casesReports[payload.caseId].isComplete = payload.isComplete;
    state.casesReports[payload.caseId].completedOn = payload.completedOn;
    state.casesReports[payload.caseId].completedBy = payload.completedBy;
  },
};

export default mutations;
